import {
  DELETE_SERVICE,
  DELETE_SERVICE_FAILURE,
  DELETE_SERVICE_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const deleteServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_SERVICE:
      return { ...state, loading: true };
    case DELETE_SERVICE_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case DELETE_SERVICE_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteServiceReducer;
